import type { IOnboardingQuestionnaireDocument } from '../types';

export function documentNeedsDetails(document: IOnboardingQuestionnaireDocument): boolean {
  return !document.document_url;
}
